import { createContext, ReactNode, useContext } from "react";
import { DataConsumer, useMyUser } from "../api";

interface DataConsumerContextType {
  currentDataConsumer: DataConsumer | null | undefined;
}

const DataConsumerContext = createContext<DataConsumerContextType | undefined>(
  undefined
);

interface DataConsumerProviderProps {
  children: ReactNode;
  userId: string;
}

export function DataConsumerProvider({
  children,
  userId,
}: DataConsumerProviderProps) {
  const currentUser = useMyUser(userId);

  const value: DataConsumerContextType = {
    currentDataConsumer: currentUser.value?.dataConsumer,
  };

  return (
    <DataConsumerContext.Provider value={value}>
      {children}
    </DataConsumerContext.Provider>
  );
}

export function useDataConsumerContext(): DataConsumerContextType {
  const context = useContext(DataConsumerContext);
  if (context === undefined) {
    throw new Error(
      "useDataConsumerContext must be used within a DataConsumerProvider"
    );
  }
  return context;
}
